<template>
  <div>
    <header>
      <div class="container inner">
        <h1>
          <img
            @click="routrRoot"
            class="logo"
            :src="compHeaderInfo.logoUrl ? compHeaderInfo.logoUrl : defaultLogo"
            alt="로고"
          />
        </h1>
        <ul class="menu-list">
          <li v-if="compHeaderInfo.isSamsung" @mouseover="overList">
            <p>강사소개 및 후기</p>
          </li>
          <li
            v-if="
              compHeaderInfo.sugang?.isCourseMenu === 'Y' && menuList.length > 0
            "
            @mouseover="overList"
          >
            <p>교육과정 안내</p>
          </li>
          <li @mouseover="overList">
            <p>공지사항</p>
          </li>
          <li v-show="chkUserInfo && store.getters.getCourseList.length !== 0">
            <p>마이페이지</p>
          </li>
          <li v-show="chkUserInfo" @click="logout">
            <p>로그아웃</p>
          </li>
        </ul>
      </div>
      <div class="sub-list">
        <ul class="container inner">
          <li v-if="compHeaderInfo.isSamsung">
            <ul>
              <li @click="dsRouter($event)">전화외국어</li>
              <li @click="dsRouter($event)">온라인 화상회화</li>
            </ul>
          </li>
          <li
            v-if="
              compHeaderInfo.sugang?.isCourseMenu === 'Y' && menuList.length > 0
            "
          >
            <ul>
              <li
                v-for="(menuItem, menuIndex) in menuList"
                :key="'menu' + menuIndex"
                @click="routerMove(menuItem)"
              >
                {{ menuItem.menuName }}
              </li>
            </ul>
          </li>
          <li>
            <ul>
              <li @click="moreRouter">공지사항</li>
              <li
                v-if="compHeaderInfo.sugang?.isFaq === 'Y'"
                @click="router.push('/common/faq')"
              >
                FAQ
              </li>
              <!-- 삼성 ds 예외처리 -->
              <li
                v-if="compHeaderInfo.isSamsung"
                @click="openUrl('https://pp7lz.channel.io/support-bots/68822')"
              >
                1:1문의
              </li>
              <!-- 만들어달라고했다가 지워달라고했다가 다시 만들어달라고했다가 또 지워놓은 히스토리 존재 그래서 해당내용 삭제하지않고 주석으로 보관 -->
              <!-- 삼성 디스플레이 예외처리 -->
              <!-- <li
                v-if="compHeaderInfo.sugang?.companyName === '삼성디스플레이'"
                @click="openUrl('https://pp7lz.channel.io/support-bots/93726')"
              >
                1:1문의
              </li>    -->
            </ul>
          </li>
          <li
            v-show="chkUserInfo && store.getters.getCourseList.length !== 0"
            @click="router.push('/myPage')"
          >
            <ul>
              수강신청 현황
            </ul>
          </li>
          <li v-show="chkUserInfo"></li>
        </ul>
      </div>
    </header>
    <ModalPopup :visible="cerModal" @closeModal="onCloseModal" />
  </div>
</template>

<script>
//기간 타입
const CUR_PEROID = 1; // 현재 기간
const NEXT_PEROID = 2; // 현재 기간이 아니면서 다음 차수 존재
const END_PEROID = 3; // 현재기간이 아니면서 다음차수 존재 X
const BEFORE_PEROID = 4; // 현재 수강신청 이전인 경우
const CLOSE_COURSE = 5; //과정이 비활성화
import ModalPopup from "@/components/ModalPopup.vue";
import { computed, onMounted, ref, watch } from "@vue/runtime-core";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import _ from "lodash";
import { certModalOpen } from "@/utils/utils";
import { getSugangInfo } from "@/api/integratedapi/index";
import { itmSugangCodeInfo } from "@/api/itmApi";
import { getCtmSugangStatus } from "@/api/ctmApi/index";
import { tracker } from "@/main";
import { setReplayUserId } from "@/plugins/sessionReplay";

export default {
  components: { ModalPopup },
  props: {
    /* 플랫폼 시작기간 */
    pltStDt: {
      type: String,
      required: false,
      default: "",
    },
    /* 플랫폼 종료기간 */
    pltEndDt: {
      type: String,
      required: false,
      default: "",
    },
  },
  setup() {
    const cssblacklist = ["main"];
    const peroidType = ref(0);
    const sugangInfo = ref({});
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const defaultLogo = ref(
      "https://kr.object.ncloudstorage.com/itmsugang/logo/logo.png",
    );
    const cerModal = ref(false);
    const courselist = ref([]);
    const headerCss = ref("");
    const chkUserInfo = ref(
      Object.keys(store.getters.getUserInfo).length == 0 ? false : true,
    );
    let compHeaderInfo = computed(() => {
      return store.getters.getHeaderInfo;
    });

    let menuList = computed(() => {
      const list = store.getters.getHeaderInfo.menulist;
      let filterList = [];
      if (Array.isArray(list) && list.length > 0) {
        filterList = list.filter((menu) => menu.isUse === "Y");
      }
      return filterList;
    });

    const routerMove = (item) => {
      const { templateIdx, isDirect, directUrl } = item;
      if (isDirect == "1") {
        window.open(directUrl);
      } else {
        let targetIdx = templateIdx;
        if (compHeaderInfo.value.isSamsung && templateIdx == 1) {
          //삼성인경우만 전화영어 페이지가 달라서 조건부여
          targetIdx = 4;
        }
        router.push(`/main?type=${targetIdx}`);
      }
    };

    const routrRoot = () => {
      router.push(`/main`);
    };

    const setHeaderCss = (routeName) => {
      if (cssblacklist.includes(routeName)) {
        headerCss.value = "go-request";
      } else {
        headerCss.value = "go-request-white";
      }
    };

    // 인증 완료 후 재호출 시 certModalOpen 체크를 건너뛰기 위해 isAuthenticated 파라미터 추가
    const applyCourse = async (isAuthenticated = false) => {
      if (!isAuthenticated) {
        const result = certModalOpen(
          store.getters.getUserInfo,
          store.getters.getCompanyInfo,
        );
        if (result) {
          cerModal.value = true;
          return;
        }
      }
      const fil = courselist.value.filter(
        (courseItem) => courseItem["isUse"] === "Y",
      );

      if (fil.length > 1) {
        router.push(`/courseSelect`);
      } else if (fil.length === 1) {
        store.commit("setSelectCourseItem", fil[0]);
        const { courseType, code, idx: courseIdx } = fil[0];
        store.commit("setCourseIdx", courseIdx);
        if (courseType === "itm") {
          const resp = await isSelectItm(code);
          const { success, data: respData } = resp.data;
          if (success) {
            const { pageIdx } = respData;
            //ITM 정보 세팅
            store.commit("setItmSugangInfo", {
              pageIdx,
              programIdx: -1,
              subjectIdx: -1,
            });
          }
        } else {
          const { data } = await getCtmSugangStatus(code);
          const { data: respData } = data;
          const { status } = respData;
          if (status !== "신청가능") {
            alert(`현재 수강신청 기간이 아닙니다.`);
            return false;
          }
          let clone = _.cloneDeep(store.getters.getCtmSugangInfo);

          if (clone) {
            clone["code"] = code;
          } else {
            clone = {
              code: code,
            };
          }

          store.commit("setCtmSugangInfo", clone);
        }
        //사용자 화면 이동
        router.push(`/common/introuduceClass?type=${courseType}`);
      } else {
        alert(`등록된 과정이 없습니다.\n매니저에게 문의해주세요`);
      }
    };

    const isSelectItm = async (code) => {
      return await itmSugangCodeInfo(code);
    };
    const onCloseModal = (isSuccessAuth) => {
      cerModal.value = false;
      if (isSuccessAuth) {
        // 인증 완료 상태를 전달하여 인증 모달이 다시 열리지 않도록 처리
        applyCourse(true);
      }
    };

    const setPeroid = () => {
      const { nextChasu, status: statusText } = sugangInfo.value;

      if (statusText === "예정") {
        peroidType.value = BEFORE_PEROID;
      } else if (statusText === "진행") {
        peroidType.value = CUR_PEROID;
      } else if (statusText === "종료") {
        //다음 차수 존재 할 경우 NEXT_PEROID
        if (nextChasu === "Y") {
          peroidType.value = NEXT_PEROID;
        } else {
          peroidType.value = END_PEROID;
        }
      }
    };

    const setSugangInfo = () => {
      if (Object.keys(store.getters.getCompanyInfo).length > 0) {
        const { code } = store.getters.getCompanyInfo;

        getSugangInfo(code)
          .then((res) => {
            const { success, data: respData } = res.data;
            store.commit("setWaitInfo", respData.sugang.isWaitInfo);
            store.commit("setisFaq", respData.sugang.isFaq);
            store.commit("setisProxy", respData.sugang.isProxy);

            if (success) {
              const { sugang, courseList, isDS } = respData;
              sugangInfo.value = sugang;
              courselist.value = courseList.filter(
                (item) => item["isUse"] === "Y",
              );
              //setPeroidType(sugangInfo.value.startDate, sugangInfo.value.endDate);
              setPeroid();
              store.commit("setHeaderInfo", {
                logoUrl: sugangInfo.value.companyLogoUrl,
                menulist: respData.menuList,
                sugang: sugangInfo.value,
                isSamsung: isDS == "Y" ? true : false,
              });
            } else {
              courselist.value = [];
              sugangInfo.value = {};
            }
          })
          .catch((error) => {
            if (error.response) {
              // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
            } else if (error.request) {
              // 요청이 이루어 졌으나 응답을 받지 못했습니다.
              // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
              // Node.js의 http.ClientRequest 인스턴스입니다.
              console.log(error.request);
            } else {
              // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
              console.log("Error", error.message);
            }
            console.log(error.config);
            sugangInfo.value = {};
          });
      }
    };
    const dsRouter = (event) => {
      const clickedText = event.target.innerText;
      if (clickedText == "전화외국어") {
        router.push(`/teacherList`);
      } else {
        router.push(`/teacherListG`);
      }
    };
    watch(
      () => route.name,
      (cur) => {
        setHeaderCss(cur);
      },
    );

    //수강 api 호출
    setSugangInfo();
    setHeaderCss(route.name);
    onMounted(() => {
      const subList = document.querySelector(".sub-list");
      subList.style.display = "none";
      subList.addEventListener("mouseleave", () => {
        subList.style.display = "none";
      });

      const menuListLi = document.querySelectorAll(".menu-list > li");

      menuListLi.forEach((item) => {
        item.addEventListener("mouseenter", () => {
          subList.style.display = "block";
        });
      });
    });
    const moreRouter = () => {
      router.push(`/notice/${store.getters.getCompanyInfo["code"]}`);
    };
    const openUrl = (url) => {
      window.open(url);
    };
    const overList = ($event) => {
      const subList = document.querySelector(".sub-list");
      subList.style.display = "block";
    };
    const logout = () => {
      alert("로그아웃 되었습니다.");
      store.commit("setUserInfo", {});
      routrRoot();
    };
    //로그인 정보 변경
    watch(
      () => store.getters.getUserInfo,
      (cur) => {
        if (Object.keys(cur).length == 0) {
          //변경된 객체의 길이가 0이면 빈값 , 사용자 정보 없음
          chkUserInfo.value = false;
        } else {
          chkUserInfo.value = true;
          tracker.setUserID(store.getters.getUserInfo.userName);
          setReplayUserId(store.getters.getUserInfo.userName);
        }
      },
    );
    return {
      store,
      router,
      CUR_PEROID,
      NEXT_PEROID,
      END_PEROID,
      BEFORE_PEROID,
      CLOSE_COURSE,
      peroidType,
      compHeaderInfo,
      menuList,
      defaultLogo,
      routerMove,
      routrRoot,
      applyCourse,
      cerModal,
      onCloseModal,
      sugangInfo,
      courselist,
      headerCss,
      dsRouter,
      moreRouter,
      openUrl,
      overList,
      logout,
      chkUserInfo,
    };
  },
};
</script>

<style lang="scss" scoped>
header {
  border-bottom: 1px solid rgba($color: $black, $alpha: 0.1);

  > .inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 2;
  }
}

header h1 {
  cursor: pointer;
}

.logo {
  height: 35px;
}

.menu-list {
  display: flex;
  align-items: center;

  > li {
    font-weight: $medium;
    color: $black;
    text-align: center;
    width: 155px;
    padding: 18px 0 24px;
    cursor: pointer;
    border-bottom: 2px solid transparent;

    &:hover {
      border-bottom: 2px solid #1e78ff;
    }
  }

  .go-request {
    color: $white;
    background-color: $black;
    padding: 6px 17px;
    border-radius: 18px;
    font-size: 14px;
  }

  .go-request-white {
    color: $black;
    background-color: $white;
    padding: 6px 17px;
    border: 1px solid $black;
    border-radius: 18px;
    font-size: 14px;
  }
}

.sub-list {
  position: absolute;
  top: 69px;
  background-color: $white;
  width: 100%;
  z-index: 1;
  box-shadow: 2px 9px 10px 0 rgba(35, 43, 54, 0.05);

  .inner {
    display: flex;
    justify-content: flex-end;
    padding: 22px 0;

    li {
      width: 155px;
      font-size: 14px;
      font-weight: $medium;
      color: #818181;
      text-align: center;
      cursor: pointer;

      &:hover {
        color: $black;
      }

      ul {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
    }
  }
}
</style>
